module.exports = __webpack_public_path__ + "static/media/gaming-1.49592c7f.png";